import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-51",
  "use": "icon-sheet_icon-51-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-51\"><g transform=\"translate(-358 -146)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"361.75\" y=\"148.75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><path d=\"M361.877 154h16.393\" /><path stroke-linecap=\"round\" d=\"M366.559 167v-12.62\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol